module.exports = __webpack_public_path__ + "img/er-3.ffaae494.png";